
    var riot = require('riot')
    //src: starling/src/tags/modal-checkout.html
riot.tag2('modal-checkout',
  '<div ref="main" class="Modal modal-checkout"> <loading></loading> <div class="modal-checkout_details"> <p class="modal-checkout_details_message">You’ve reached your limit of {FREE_CARD_LIMIT} free cards</p> <h3 class="modal-checkout_details_title">Upgrade to Plectica Pro for unlimited cards…</h3> <ul class="modal-checkout_details_list"> <li class="modal-checkout_details_list_item"> <svg class="modal-checkout_details_list_item_icon"> <use xlink:href="#check_circle-icon"></use> </svg> Unlimited cards for your ideas </li> <li class="modal-checkout_details_list_item"> <svg class="modal-checkout_details_list_item_icon"> <use xlink:href="#check_circle-icon"></use> </svg> Attach files up to {SUBSCRIBER_FILE_MAX_SIZE / 1000000}MB </li> <li class="modal-checkout_details_list_item"> <svg class="modal-checkout_details_list_item_icon"> <use xlink:href="#check_circle-icon"></use> </svg> Long term backups </li> <li class="modal-checkout_details_list_item"> <svg class="modal-checkout_details_list_item_icon"> <use xlink:href="#check_circle-icon"></use> </svg> Priority support services </li> </ul> <div class="modal-checkout_details_summary"> <label class="modal-checkout_details_summary_label"> <input class="modal-checkout_details_summary_input" type="checkbox" checked onclick="{togglePlan}"> {plan.billingInterval == \'annual\' ? \'Annual \' : \'Monthly \'} subscription* </label> <span> ${plan.billingInterval == \'annual\' ? plan.price/12 : plan.price} per month {plan.billingInterval == \'annual\' ? \'billed annually\' : \'\'} <span> </div> <div class="modal-checkout_details_summary"> <span style="font-size: 18px; font-weight: bold;">Total due today</span> <span class="modal-checkout_details_summary_total">${plan.price}</span> </div> <p class="modal-checkout_details_footnote">*Your subscription will be renewed every {plan.billingInterval === \'annual\' ? \'year\' : \'month\'}. You may cancel at any time.</p> </div> <div class="modal-checkout_form" ref="form"> <div class="modal-chieckout_form_spinner spinner" ref="spinner"> <div class="bounce1"></div> <div class="bounce2"></div> <div class="bounce3"></div> </div> <header class="modal-checkout_form_header"> <h2 class="modal-checkout_form_title">Payment details</h2> <button class="Modal_close" onclick="{hide}"> <svg class="Modal_close_icon"> <use xlink:href="#close-icon"></use> </svg> </button> </header> <form onsubmit="{onSubmit}" style="display: flex; flex-direction: column;"> <label class="modal-checkout_form_label" for="name-on-card">Name</label> <input id="name-on-card" class="modal-checkout_form_input" riot-value="{user && user.display_name}" required> <label class="modal-checkout_form_label" for="card-number">Credit card number</label> <div class="modal-checkout_form_input" id="card-number"></div> <div class="modal-checkout_form_row"> <div class="modal-checkout_form_row_item"> <label class="modal-checkout_form_label" for="card-expiry">Expiration Date</label> <div class="modal-checkout_form_input" id="card-expiry"></div> </div> <div class="modal-checkout_form_row_item"> <label class="modal-checkout_form_label" for="card-cvc">Security Code</label> <div class="modal-checkout_form_input" id="card-cvc"></div> </div> <div class="modal-checkout_form_row_item"> <label class="modal-checkout_form_label" for="postal-code">Billing ZIP code</label> <div class="modal-checkout_form_input" id="postal-code"></div> </div> </div> <div ref="errors" role="alert" class="modal-checkout_form_errors"></div> <button ref="submitButton" class="Button Button--Primary Button--Large Button--Full" type="submit">Complete upgrade</button> <svg width="119px" height="26px" style="align-self: center; margin-top: 16px;"> <use xlink:href="#stripe-outline-logo"></use> </svg> </form> </div> </div>',
  '',
  'show="{isVisible}" class="Modal_overlay"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _upsellUi = require('lib/upsell-ui');

this.FREE_CARD_LIMIT = _constants.FREE_CARD_LIMIT;
this.SUBSCRIBER_FILE_MAX_SIZE = _constants.SUBSCRIBER_FILE_MAX_SIZE;

this.plan = window.subscriptionProducts['basic-annual'];

var _opts = opts,
    canvas = _opts.canvas;

var style = {
  base: {
    color: '#5d6a7b',
    fontFamily: '"Roboto", "Arial", sans-serif',
    fontSize: '16px',
    '::placeholder': {
      color: '#CFD7DF'
    }
  }
};

this.isVisible = false;

canvas.modalCheckout = this;

this.show = function (banner) {
  _this.isVisible = true;

  if (!_this.stripe) {
    _this.showInitializing();

    $.ajax({
      url: 'https://js.stripe.com/v3/',
      dataType: 'script',
      success: function success() {
        _this.stripe = Stripe(window.config.paymentKey);
        _this.createStripeElements();
        _this.hideInitializing();
      }
    });
  }

  if (banner) {
    _this.banner = banner;

    $.ajax({
      method: 'POST',
      url: '/api/banners/checkout',
      data: { trigger: banner }
    });
  }

  _this.update();
};

this.hide = function () {
  _this.isVisible = false;
  delete _this.banner;
  _this.update();
};

this.togglePlan = function (e) {
  _this.plan = e.target.checked ? window.subscriptionProducts['basic-annual'] : window.subscriptionProducts['basic-monthly'];
  _this.update();
};

this.createStripeElements = function () {
  var elements = _this.stripe.elements();

  var card = _this.card = elements.create('cardNumber', {
    style: style,
    placeholder: '0000 0000 0000 0000'
  });

  card.mount('#card-number');

  var cardExpiry = elements.create('cardExpiry', {
    style: style,
    placeholder: 'MM / YY'
  });

  cardExpiry.mount('#card-expiry');

  var cardCvc = elements.create('cardCvc', {
    style: style,
    placeholder: '000'
  });

  cardCvc.mount('#card-cvc');

  var postalCode = elements.create('postalCode', {
    style: style,
    placeholder: '00000'
  });

  postalCode.mount('#postal-code');

  // error handling
  card.addEventListener('change', _this.handleFieldError);
  cardExpiry.addEventListener('change', _this.handleFieldError);
};

this.handleFieldError = function (_ref) {
  var error = _ref.error;

  if (error) {
    _this.setError(error.message);
  } else {
    _this.clearErrors();
    _this.hideLoading();
  }
};

this.onSubmit = function (event) {
  event.preventDefault();
  _this.showLoading();

  _this.stripe.createToken(_this.card).then(function (_ref2) {
    var error = _ref2.error,
        token = _ref2.token;

    if (error) {
      _this.setError(error.message);
      _this.hideLoading();
    } else {
      _this.stripeTokenHandler({ token: token });
    }
  });
};

this.stripeTokenHandler = function (_ref3) {
  var token = _ref3.token;

  var data = {
    payment_token: token.id,
    plan_id: _this.plan.planId
  };
  if (_this.banner) {
    data.trigger = _this.banner;
  }

  $.ajax({
    method: 'POST',
    url: '/api/subscriptions/new',
    data: data
  }).then(_this.responseHandler).catch(_this.exceptionResponseHandler);
};

this.responseHandler = function (_ref4) {
  var status = _ref4.status,
      message = _ref4.message,
      order_key = _ref4.order_key;

  // handle results from API responses
  if (status === 'success') {
    _this.hide();
    canvas.showPaymentConfirmationModal({ orderKey: order_key, planId: _this.plan.planId });
    _upsellUi.usui.subscribe(_this.plan.planId);
  } else {
    _this.setError(message);
    _this.hideLoading();
  }
};

this.exceptionResponseHandler = function (error) {
  _this.setError('Please try again in a few moments');
  _this.hideLoading();
};

this.setError = function (message) {
  _this.refs.errors.textContent = message;
};

this.clearErrors = function () {
  _this.refs.errors.textContent = '';
};

this.showInitializing = function () {
  _this.refs.main.classList.add('modal-checkout--initializing');
};

this.hideInitializing = function () {
  _this.refs.main.classList.remove('modal-checkout--initializing');
};

this.showLoading = function () {
  if (_this._loading) return;
  _this._loading = true;
  _this.refs.form.classList.add('modal-checkout_form--loading');
  var button = _this.refs.submitButton;
  button.setAttribute('disabled', 'disabled');
  _this._buttonText = button.innerText;
  button.innerText = 'Processing…';
};

this.hideLoading = function () {
  if (!_this._loading) return;
  _this._loading = false;
  var button = _this.refs.submitButton;
  button.innerText = _this._buttonText;
  _this.refs.submitButton.removeAttribute('disabled');
  _this.refs.form.classList.remove('modal-checkout_form--loading');
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-checkout')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-checkout.html
// module id = 745
// module chunks = 0